import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql, withApollo } from 'react-apollo';
import gql from 'graphql-tag';
import { Nav, NavItem } from 'react-bootstrap';
import PointValueDisplay from 'components/PointValueDisplay';
import TicketIcon from 'components/TicketIcon';
import { errorShape } from 'utils/shapes';

const SUBSCRIPTION_UPDATE_DELAY = 4000;

class PatronAssets extends Component {
  constructor(props) {
    super(props);

    this.unsubscribeFromNewData = () => {};
    this.state = {
      wscore: 0,
      wscoreInterval: null,
      wscoreAnimationFinished: false,
      scaleWScore: false
    };

    this.incrementWScore = this.incrementWScore.bind(this);
  }

  componentDidMount() {
    this.unsubscribeFromNewData = this.props.subscribeToNewData();
  }

  componentWillUnmount() {
    this.unsubscribeFromNewData();
    this.unsubscribeFromNewData = () => {};
  }

  componentWillReceiveProps(nextProps) {
    const { data: { patronAssets } } = nextProps;
    const { wscore, wscoreInterval } = this.state;

    if (patronAssets) {
      const newWScore = patronAssets.wscore;

      if (wscore !== newWScore && !wscoreInterval) {
        const wscoreDiff = newWScore - wscore;
        const increment = wscoreDiff / 20;

        const wscoreInterval = setInterval(
          this.incrementWScore.bind(this, wscore, newWScore, increment),
          50
        );

        this.setState({
          wscoreInterval,
          scaleWScore: true
        });

        setTimeout(this.resetScaleWScore.bind(this), 500);
      }
    }
  }

  resetScaleWScore() {
    this.setState({ scaleWScore: false });
  }

  incrementWScore(originalWScore, newWScore, increment) {
    const { wscoreInterval, wscore } = this.state;
    const incrementedWScore = wscore + increment;
    const updatedWScore =
      incrementedWScore < newWScore ? incrementedWScore : newWScore;

    if (updatedWScore === newWScore) {
      clearInterval(wscoreInterval);

      this.setState({
        wscoreInterval: null
      });
    }

    this.setState({
      wscore: updatedWScore,
      wscoreAnimationFinished: updatedWScore === newWScore
    });
  }

  render() {
    const {
      data: { patronAssets, loading, error },
      isMobile,
      isGaming
    } = this.props;

    const { wscore, scaleWScore } = this.state;

    if (!patronAssets || loading || error) {
      return null;
    }

    const { tickets, points } = patronAssets;
    let className = '';
    if (isMobile) {
      className = 'mobile-patron-assets';
    }

    if (isGaming) {
      className = 'gaming-patron-assets';
    }

    return (
      <Nav className={className}>
        {!isGaming &&
          !isMobile && (
            <NavItem>
              <PointValueDisplay icon={<TicketIcon />} pointValue={tickets} />
            </NavItem>
          )}
        <NavItem>
          <PointValueDisplay
            scale={scaleWScore}
            label="W Score"
            pointValue={Math.ceil(wscore)}
          />
        </NavItem>
        {!isGaming && (
          <NavItem>
            <PointValueDisplay label="Points" pointValue={points} />
          </NavItem>
        )}
        {!isGaming &&
          isMobile && (
            <NavItem>
              <PointValueDisplay
                label="Tickets"
                icon={<TicketIcon />}
                pointValue={tickets}
              />
            </NavItem>
          )}
      </Nav>
    );
  }
}

PatronAssets.propTypes = {
  data: PropTypes.shape({
    patronAssets: PropTypes.shape({
      points: PropTypes.number,
      tickets: PropTypes.number,
      wscore: PropTypes.number
    }),
    loading: PropTypes.bool,
    error: errorShape
  }),
  isMobile: PropTypes.bool,
  isGaming: PropTypes.bool
};

const patronAssetsQuery = gql`
  query {
    patronAssets {
      points
      tickets
      wscore
    }
  }
`;

const SUBSCRIPTION_WSCORE = gql`
  subscription {
    wScoreUpdates {
      wScore
    }
  }
`;

const PatronAssetsWithData = withApollo(
  graphql(patronAssetsQuery, {
    options: { fetchPolicy: 'cache-and-network' },
    props: props => {
      return {
        ...props,
        subscribeToNewData: params => {
          return props.data.subscribeToMore({
            document: SUBSCRIPTION_WSCORE,
            updateQuery: (prev, { subscriptionData }) => {
              const wScore = subscriptionData.data.wScore;

              setTimeout(() => {
                let prevData = props.ownProps.client.readQuery({
                  query: patronAssetsQuery
                });

                props.ownProps.client.writeQuery({
                  query: patronAssetsQuery,
                  data: {
                    patronAssets: {
                      ...prevData.patronAssets,
                      ...{ wscore: wScore }
                    }
                  }
                });
              }, SUBSCRIPTION_UPDATE_DELAY);

              return prev;
            }
          });
        }
      };
    }
  })(PatronAssets)
);

export default PatronAssetsWithData;



// WEBPACK FOOTER //
// ./src/containers/PatronAssets/index.js